import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { login } from '../services/auth';
import { getProfile as getBranchUserProfile } from '../services/branch_users';
import { USER_ROLE, USER_PROFILE } from '../services/auth';

const Login = () => {
  const [form, setForm] = useState({ code: '', password: '' });
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleChange = e => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleLogin = async e => {
    e.preventDefault();

    if (!form.code || !form.password) {
      setError('Username and Password are required');
      return;
    }

    try {
      await login(form);
      await cacheProfile();
      navigate('/dashboard');
    } catch (err) {
      setError('Invalid credentials. Please try again.');
    }
  };

  const cacheProfile = async () => {
    const role = localStorage.getItem(USER_ROLE);
    if (['branch_admin', 'branch_user'].includes(role)) {
      const [err, data] = await getBranchUserProfile();
      if (err) {
        throw 'Error Occurred.';
      }
      localStorage.setItem(USER_PROFILE, JSON.stringify(data));
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="w-full max-w-sm bg-white p-6 rounded-lg shadow-lg border-t-4 border-[#E91C24]">
        {/* Logo */}
        <div className="flex justify-center mb-6">
          <img src="/logo_rapidelo.png" alt="Logistics Logo" className="h-24 w-auto" />
        </div>

        <h2 className="text-2xl font-bold text-center text-[#293686] mb-4">Login</h2>

        {error && <div className="text-[#E91C24] text-sm text-center mb-3">{error}</div>}

        <form onSubmit={handleLogin} className="space-y-5">
          <div>
            <label className="block text-sm font-medium text-gray-700">Username</label>
            <input
              type="text"
              className="w-full mt-1 px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-[#E91C24] border-gray-300"
              name="code"
              onChange={handleChange}
              required
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">Password</label>
            <div className="relative mt-1">
              <input
                type={showPassword ? 'text' : 'password'}
                className="w-full px-3 py-2 border rounded-md pr-12 focus:outline-none focus:ring-2 focus:ring-[#E91C24] border-gray-300"
                name="password"
                onChange={handleChange}
                required
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className="absolute inset-y-0 right-2 text-sm text-[#293686] hover:underline focus:outline-none"
              >
                {showPassword ? 'Hide' : 'Show'}
              </button>
            </div>
          </div>

          <div>
            <button
              type="submit"
              className="w-full bg-[#E91C24] text-white py-2 rounded-md hover:bg-[#c3151d] transition"
            >
              Login
            </button>
          </div>
          <div className="text-center mt-2">
            <button
              type="button"
              className="text-sm text-[#293686] hover:underline"
              onClick={() => navigate('/forgot-password')}
            >
              Forgot Password?
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Login;
